import { ColorProperty } from "./colorproperty";

export class TextColorProperty extends ColorProperty{
    
}